import { FunctionalComponent, h } from 'preact'
import { CSSProperties } from 'preact/compat'
import Svg from './Svg'

type Props = {
  className?: string
  style?: CSSProperties
  onClick?: () => void
}

const Close: FunctionalComponent<Props> = ({ className = '' }) => {
  return (
    <Svg
      width={10}
      height={10}
      viewBox="0 0 12 12"
      className={className}
      path="M11.7803 1.28033C12.0732 0.987437 12.0732 0.512563 11.7803 0.21967C11.4874 -0.0732233 11.0126 -0.0732233 10.7197 0.21967L6 4.93934L1.28033 0.21967C0.987437 -0.0732233 0.512563 -0.0732233 0.21967 0.21967C-0.0732233 0.512563 -0.0732233 0.987437 0.21967 1.28033L4.93934 6L0.21967 10.7197C-0.0732233 11.0126 -0.0732233 11.4874 0.21967 11.7803C0.512563 12.0732 0.987437 12.0732 1.28033 11.7803L6 7.06066L10.7197 11.7803C11.0126 12.0732 11.4874 12.0732 11.7803 11.7803C12.0732 11.4874 12.0732 11.0126 11.7803 10.7197L7.06066 6L11.7803 1.28033Z"
    />
  )
}

const FeedbackStar: FunctionalComponent<Props> = ({ className, onClick, style }) => {
  return (
    <Svg
      viewBox="0 0 38 35"
      className={className}
      onClick={onClick}
      style={style}
      path="M18.2153 0.589806C18.5363 -0.0605344 19.4637 -0.060534 19.7846 0.589806L24.6743 10.4973C24.8017 10.7555 25.0481 10.9345 25.3331 10.9759L36.2666 12.5647C36.9843 12.6689 37.2709 13.5509 36.7515 14.0571L28.84 21.769C28.6337 21.97 28.5396 22.2597 28.5883 22.5435L30.456 33.4329C30.5786 34.1477 29.8283 34.6927 29.1864 34.3553L19.4072 29.214C19.1523 29.08 18.8477 29.08 18.5928 29.214L8.81357 34.3553C8.17165 34.6927 7.4214 34.1476 7.54399 33.4329L9.41166 22.5435C9.46035 22.2597 9.36624 21.97 9.16002 21.769L1.24844 14.0571C0.729114 13.5509 1.01569 12.6689 1.73338 12.5647L12.6669 10.9759C12.9519 10.9345 13.1983 10.7555 13.3257 10.4973L18.2153 0.589806Z"
    />
  )
}

const Screenshot: FunctionalComponent<Props> = ({ className = '' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_10656_65238)">
        <path
          d="M5.25 14.25C4.85218 14.25 4.47064 14.092 4.18934 13.8107C3.90804 13.5294 3.75 13.1478 3.75 12.75"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 9.75V8.25"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 5.25C3.75 4.85218 3.90804 4.47064 4.18934 4.18934C4.47064 3.90804 4.85218 3.75 5.25 3.75"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 3.75H9.75"
          stroke="currentColor"
          strokeWidth="1.13684"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.75 3.75C13.1478 3.75 13.5294 3.90804 13.8107 4.18934C14.092 4.47064 14.25 4.85218 14.25 5.25"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 8.25V9.75"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 12.75V15.75"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 14.25H12.75"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.75 14.25H8.25"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10656_65238">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const Loader: FunctionalComponent<Props> = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <line x1="12" y1="6" x2="12" y2="3" />
      <line x1="16.25" y1="7.75" x2="18.4" y2="5.6" />
      <line x1="18" y1="12" x2="21" y2="12" />
      <line x1="16.25" y1="16.25" x2="18.4" y2="18.4" />
      <line x1="12" y1="18" x2="12" y2="21" />
      <line x1="7.75" y1="16.25" x2="5.6" y2="18.4" />
      <line x1="6" y1="12" x2="3" y2="12" />
      <line x1="7.75" y1="7.75" x2="5.6" y2="5.6" />
    </svg>
  )
}

const StarOutline: FunctionalComponent<Props> = () => {
  return (
    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7758 1.14891C11.8675 0.963099 12.1325 0.963098 12.2242 1.14891L14.9154 6.60187C15.1703 7.11837 15.663 7.47637 16.233 7.55919L22.2507 8.43362C22.4558 8.46341 22.5377 8.71541 22.3893 8.86004L18.0348 13.1046C17.6224 13.5066 17.4342 14.0859 17.5315 14.6536L18.5595 20.6469C18.5945 20.8512 18.3801 21.0069 18.1967 20.9105L12.8143 18.0808C12.3045 17.8128 11.6955 17.8128 11.1857 18.0808L5.80326 20.9105C5.61985 21.0069 5.40549 20.8512 5.44052 20.6469L6.46847 14.6536C6.56583 14.0859 6.37762 13.5066 5.96517 13.1046L1.61072 8.86004C1.46235 8.71541 1.54422 8.46341 1.74928 8.43362L7.76698 7.55919C8.33697 7.47637 8.82971 7.11837 9.08462 6.60187L11.7758 1.14891Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  )
}

const StarFill: FunctionalComponent<Props> = () => {
  return (
    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1033 0.816986C11.4701 0.0737399 12.5299 0.0737401 12.8967 0.816986L15.5879 6.26995C15.7336 6.56509 16.0152 6.76966 16.3409 6.81699L22.3586 7.69141C23.1788 7.8106 23.5063 8.81857 22.9128 9.39711L18.5583 13.6416C18.3227 13.8714 18.2151 14.2024 18.2707 14.5268L19.2987 20.5202C19.4388 21.3371 18.5814 21.96 17.8477 21.5743L12.4653 18.7446C12.174 18.5915 11.826 18.5915 11.5347 18.7446L6.15226 21.5743C5.41864 21.96 4.5612 21.3371 4.70131 20.5202L5.72926 14.5268C5.7849 14.2024 5.67735 13.8714 5.44166 13.6416L1.08721 9.3971C0.493698 8.81857 0.821208 7.8106 1.64143 7.69141L7.65913 6.81699C7.98484 6.76966 8.2664 6.56509 8.41207 6.26995L11.1033 0.816986Z"
        fill="currentColor"
      />
    </svg>
  )
}

const Picture: FunctionalComponent<Props> = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.1256 4C26.6229 4 27.0998 4.19754 27.4515 4.54917C27.8031 4.90081 28.0006 5.37772 28.0006 5.875V25.1247C28.0006 25.622 27.8031 26.0989 27.4515 26.4505C27.0998 26.8021 26.6229 26.9997 26.1256 26.9997H3.875C3.37772 26.9997 2.90081 26.8021 2.54917 26.4505C2.19754 26.0989 2 25.622 2 25.1247V5.875C2 5.37772 2.19754 4.90081 2.54917 4.54917C2.90081 4.19754 3.37772 4 3.875 4H26.1256ZM17.2456 16.8578C17.1824 16.9066 17.1257 16.9634 17.0769 17.0266L11.9862 23.6134C11.879 23.752 11.8127 23.9179 11.795 24.0922C11.7773 24.2666 11.8087 24.4424 11.8858 24.5998C11.963 24.7571 12.0826 24.8897 12.2313 24.9825C12.3799 25.0753 12.5516 25.1245 12.7269 25.1247H22.9081C23.0835 25.1249 23.2555 25.0759 23.4044 24.9832C23.5533 24.8906 23.6733 24.758 23.7506 24.6006C23.828 24.4432 23.8596 24.2672 23.8419 24.0927C23.8242 23.9182 23.758 23.7521 23.6506 23.6134L18.56 17.0266C18.408 16.83 18.1842 16.7018 17.9377 16.6702C17.6913 16.6385 17.4423 16.706 17.2456 16.8578ZM8.50063 10C8.16827 9.99356 7.83796 10.0535 7.52903 10.1762C7.2201 10.2989 6.93875 10.4821 6.70142 10.7148C6.4641 10.9476 6.27558 11.2253 6.14688 11.5318C6.01819 11.8383 5.9519 12.1674 5.9519 12.4998C5.9519 12.8323 6.01819 13.1613 6.14688 13.4678C6.27558 13.7743 6.4641 14.0521 6.70142 14.2849C6.93875 14.5176 7.2201 14.7007 7.52903 14.8235C7.83796 14.9462 8.16827 15.0061 8.50063 14.9997C9.15524 14.987 9.77877 14.7181 10.2372 14.2506C10.6957 13.7832 10.9525 13.1546 10.9525 12.4998C10.9525 11.8451 10.6957 11.2165 10.2372 10.7491C9.77877 10.2816 9.15524 10.0127 8.50063 10Z"
        fill="#E9ECEF"
      />
    </svg>
  )
}

const Message: FunctionalComponent<Props> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M24 5C24 6.65685 22.6569 8 21 8C19.3431 8 18 6.65685 18 5C18 3.34315 19.3431 2 21 2C22.6569 2 24 3.34315 24 5Z"
        fill="#FAB005"
      />
      <path
        d="M17.2339 7.46394L15.6973 8.74444C14.671 9.59966 13.9585 10.1915 13.357 10.5784C12.7747 10.9529 12.3798 11.0786 12.0002 11.0786C11.6206 11.0786 11.2258 10.9529 10.6435 10.5784C10.0419 10.1915 9.32941 9.59966 8.30315 8.74444L5.92837 6.76546C5.57834 6.47377 5.05812 6.52106 4.76643 6.87109C4.47474 7.22112 4.52204 7.74133 4.87206 8.03302L7.28821 10.0465C8.2632 10.859 9.05344 11.5176 9.75091 11.9661C10.4775 12.4334 11.185 12.7286 12.0002 12.7286C12.8154 12.7286 13.523 12.4334 14.2495 11.9661C14.947 11.5176 15.7372 10.859 16.7122 10.0465L18.3785 8.65795C17.9274 8.33414 17.5388 7.92898 17.2339 7.46394Z"
        fill="#FAB005"
      />
      <path
        d="M18.4538 6.58719C18.7362 6.53653 19.0372 6.63487 19.234 6.87109C19.3965 7.06614 19.4538 7.31403 19.4121 7.54579C19.0244 7.30344 18.696 6.97499 18.4538 6.58719Z"
        fill="#FAB005"
      />
      <path
        opacity="0.5"
        d="M16.9576 3.02099C16.156 3 15.2437 3 14.2 3H9.8C5.65164 3 3.57746 3 2.28873 4.31802C1 5.63604 1 7.75736 1 12C1 16.2426 1 18.364 2.28873 19.682C3.57746 21 5.65164 21 9.8 21H14.2C18.3484 21 20.4225 21 21.7113 19.682C23 18.364 23 16.2426 23 12C23 10.9326 23 9.99953 22.9795 9.1797C22.3821 9.47943 21.7103 9.64773 21 9.64773C18.5147 9.64773 16.5 7.58722 16.5 5.04545C16.5 4.31904 16.6646 3.63193 16.9576 3.02099Z"
        fill="#FAB005"
      />
    </svg>
  )
}

export default { Close, FeedbackStar, Screenshot, Loader, StarFill, StarOutline, Picture, Message }
